import {setGAUserProperties}   from "@Common/libs/ga/xd-react-ga";
import {cs}                    from "@Common/react/chain-services";
import {consumeContext}        from "@Common/react/context";
import {isDevQuan}             from "@Common/ui-components/debug/is-dev-quan";
import {buildUrlQuery}         from "@Common/utils/build-url-query";
import {parseUrlQuery}         from "@Common/utils/parse-url-query";

import {EnsureItemAddedToCart} from "../../../../../common/logic/cart-logic/ensure-item-added-to-cart";
import {postFormHttp}          from "../post-form-http";

export const RedirectStep = (
    {
        status,
        customizeFlow,
        isFromApproval,
        isKit,
        location,
        build3Cond,
        forceBuild3,
        next,
    }
) => cs(
    ["redirect", (_, next) => Redirect({customizeFlow, status, location, isFromApproval, isKit, build3Cond, forceBuild3, next})],
    ({redirect}) => next(async ({newItem, type, approval, isKit, forceCustomize, reset}) => {
        if (newItem?.itemId) {
            setGAUserProperties({idOrder: newItem?.itemId});
            await redirect({item: newItem, type, approval, isKit, forceCustomize, reset});
        } else {
            status.error();
        }
    }),
);

const Redirect = ({customizeFlow, status, isFromApproval, isKit, location, build3Cond, forceBuild3, next,}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("routerHistory"),
    consumeContext("templateOptions"),
    ["ensureItemAddedToCart", (_,next) => EnsureItemAddedToCart({next})],
    ["cartId", (_, next) => next(parseUrlQuery(location.search)?.id_cart)],
    ({apis, ensureItemAddedToCart, templateOptions, cartId, company, routerHistory}) => next(async ({item, type, approval, forceCustomize, reset}) => {
        window.history.replaceState(window.history.state,null,
            routerHistory.createHref({pathname:`/product-options/order/${item.itemId}` +
                buildUrlQuery({
                    ...isFromApproval && {
                        id_cart: cartId,
                        referrer: "approval-requests",
                    }
                })
            })
        );
        if (approval && type !== "updateForceAgent") {
            status.redirecting("Checkout");
            if(!customizeFlow.afterProofApproval) {
                routerHistory.push(`/checkout/${cartId}` + buildUrlQuery({
                    referrer: 'approval-requests',
                }));
            } else {
                routerHistory.push(`/distribution-options/order/${item.itemId}` + buildUrlQuery({
                    id_cart: cartId,
                    referrer: 'approval-requests',
                }));
            }
        } else if(company?.prefs?.xpressoKitOptionsActive && isKit) {
            status.redirecting("Kit Options");
            routerHistory.push(`/kit-options/order/${item.itemId}` + buildUrlQuery({
                ...isFromApproval && {
                    id_cart: cartId,
                    referrer: "approval-requests",
                },
            }));
        } else if (customizeFlow.legacy) {
            if (customizeFlow.legacy.xpressoCheckout && !forceCustomize) {
                status.redirecting("Checkout");
                if (customizeFlow.needsDistributionOptions) {
                    routerHistory.push(`/distribution-options/order/${item.itemId}` + buildUrlQuery({
                        ...isFromApproval && {
                            id_cart: cartId,
                            referrer: "approval-requests",
                        },
                    }));
                } else if(isFromApproval) {
                    status.redirecting("Checkout");
                    if(!customizeFlow.afterProofApproval) {
                        routerHistory.push(`/checkout/${cartId}` + buildUrlQuery({
                            referrer: 'approval-requests',
                        }));
                    } else {
                        routerHistory.push(`/distribution-options/order/${item.itemId}` + buildUrlQuery({
                            id_cart: cartId,
                            referrer: 'approval-requests',
                        }));
                    }
                } else {
                    if( templateOptions?.proofEngineType === 8 ) {
                        const proof = await apis.next.initiateProofing( item.itemId, 0 );
                        if( proof['error'] ) {
                            status.error();
                            return;
                        }
                    }
                    const {cartId} = await ensureItemAddedToCart({item});
                    setGAUserProperties({idCart: cartId});
                    routerHistory.push(`/checkout/${cartId}` + buildUrlQuery({
                        ...isFromApproval && {
                            referrer: "approval-requests",
                        },
                    }));
                }
            // build3Cond now only checks for buildpaths that are not included in the BUILD3_SUPPORTED_BUILDPATHS system constant.
            // If we are using the Bug Bounty tool to force Build3, it should allow us through.
            } else if ( (company.prefs.allowBuild3 || forceBuild3.value) && (!build3Cond || forceBuild3.value) && templateOptions?.proofEngineType !== 8) {
                status.redirecting("Customization");
                routerHistory.push(`/customize/order/${item.itemId}` + buildUrlQuery({
                    ...isFromApproval && {
                        id_cart: cartId,
                        referrer: "approval-requests",
                    },
                    ...reset && {reset},
                }));
            } else {
                status.redirecting("Customization");
                submitLegacyTemplateNew({itemId:item.itemId, type, isFromApproval});
            }
        } else {
            status.redirecting("Customization");
            routerHistory.push(`/customize/order/${item.itemId}` + buildUrlQuery({
                ...isFromApproval && {
                    id_cart: cartId,
                    referrer: "approval-requests",
                },
            }));
        }
    }),
);

export const submitLegacyTemplateNew = ({itemId, type, isFromApproval}) => {
    if (isDevQuan() && !confirm("DEV QUAN allow redirecting to legacy start.php?")) {
        return;
    }
    postFormHttp("/next/start.php", {
        action: "edit",
        redirect: "customize",
        id_order: itemId,
        order_exists: "exists",
        procform: 1,
        ...isFromApproval && {
            approval: 1,
        },
        force_agent_update: ["updateForceAgent", "createNew"].includes(type) ? 1 : 0
    });
};
